import { Button, Grid, LinearProgress } from 'material-ui';
import { withStyles } from 'material-ui/styles';
import React from 'react';
import { translate } from 'react-i18next';
import { getAvailability } from '../../services/transfersService';
import Pagination from '../../ui/Pagination';
import OLYWebPageComponent from '../OLYWebPageComponent';
import DynIcon from '../Utils/DynIcon';
import TransferCardRender from './TransferCardRender';
import { updateLandScapeForm } from '../Utils/FilterChangeFunctions';

const styles = theme => ({

});

class TransfersResults extends OLYWebPageComponent {
    constructor(props) {
        super(props);
        this.state = {
            request: null,
            response: null,
            result: [],
            dataprovider: [],
            sorted: true,
            total: 0,
            currentPage: 0
        };

        this.pageTitle = 'Transfer Results';
        this.pageName = 'TransferResults';
        this.pageReference = 'https://xcaleconsulting.atlassian.net/wiki/spaces/OL/pages/653459479/TransferResults';
    }

    onHashChanged = (hash) => {
        if (hash && hash.parts) {
            let result_key = hash.parts[2];
            let raw = window.localStorage.getItem(result_key);
            let req = JSON.parse(raw);
            this.setState({ request: req, raw: raw, resultToken: result_key },
                () => this.getServerResult());
        }
    }

    getServerResult = () => {
        let key = this.state.resultToken;
        this.setState({ loading: true });
        getAvailability(key, null).then(data => {
            updateLandScapeForm('result', data);
            this.setState({
                response: data,
                result: data.result,
                dataprovider: this.paginate(data.result, 10, 0),
                currentPage: 0,
                total: data.result.length,
                loading: false
            });
        }).catch(e => {
            this.setState({ loading: false });
            alert(e.message);
        });
    }

    paginate = (array, page_size, page_number) => {
        //--page_number; // because pages logically start with 1, but technically with 0
        return array.slice(page_number * page_size, (page_number + 1) * page_size);
    }

    navigateToPage = data => {
        this.setState({
            currentPage: data.number,
            dataprovider: this.paginate(this.state.result, 10, data.number - 1),
        });
    };

    sortResult = () => {
        let thestate = this.state;
        thestate.sorted = !thestate.sorted;
        if (thestate.sorted) {
            thestate.dataprovider = thestate.result.sort((a, b) => a.pvp - b.pvp);
        } else {
            thestate.dataprovider = thestate.result.sort((a, b) => b.pvp - a.pvp);
        }
        thestate.currentPage = 0;
        thestate.dataprovider = this.paginate(thestate.dataprovider, 10, 0);
        this.setState(thestate);
    }

    render() {
        const { classes, t } = this.props;
        return (
            <div className="cmsResults">
                <div className="cmsContainer">
                <div className="searchbar">
                    {this.state.loading ? <LinearProgress className="cmsProgressBar" /> : ''}
                </div>
                <div className="cmsTransfer">
                    <Grid container alignItems="center" justify="flex-end" style={{ margin: 0, paddingRight: '8px' }}>
                        <Grid item>
                            <Button style={{
                                backgroundColor: '#ffffff'
                            }}>
                                <DynIcon icon="DirectionsBus" className={classes.colorIcon} />
                                {t('TRANSFERS.RESULT', { count: this.state.total })}
                            </Button>
                        </Grid>
                        <Grid item>
                            <strong>{t('RESULTS.SORT')}</strong>
                            <Button
                                style={{
                                    backgroundColor: '#ffffff'
                                }}
                                onClick={this.sortResult}>
                                <DynIcon icon="Sort" className={classes.colorIcon} />
                                {this.state.sorted ? t('COMMON.PRICE_ASC') : t('COMMON.PRICE_DESC')}&nbsp;
                                {this.state.sorted ?
                                    <DynIcon icon="ArrowDropDown" className={classes.colorIcon} style={{ position: 'absolute', right: 0, }} />
                                    :
                                    <DynIcon icon="ArrowDropUp" className={classes.colorIcon} style={{ position: 'absolute', right: 0, }} />
                                }
                            </Button>
                        </Grid>
                    </Grid>
                    <div>
                        {this.state.response ? (<div>
                            {this.state.dataprovider.map(item => {
                                return <TransferCardRender transfer={item} token={this.props.token} user={this.currentUser} />;
                            })}
                        </div>) : 'No response available'}
                        <div className="centercontent">
                            <Pagination
                                total={Math.ceil(this.state.total / 10)}
                                current={this.state.currentPage}
                                display={10}
                                onChange={number => this.navigateToPage({ number })}
                                colorAux={{ backgroundColor: '#ff0000' }}
                            />
                        </div>
                    </div>
                </div>
                </div>
            </div>
        );
    }
}
export default translate('translations')(withStyles(styles)(TransfersResults));


// WEBPACK FOOTER //
// ./src/components/Transfers/TransfersResults.js